import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ReduxStoreModule } from '../redux-store';
import { environment } from '../environments/environment';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';
import { ClientDetailsApiInterceptor, GeneralApiHttpInterceptor, TranslationLoaderFactory } from '@monorepo/services';
import { NavigationService } from '../guard/navigation.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

@NgModule({
  declarations: [AppComponent],
  imports: [
    IonicStorageModule.forRoot({
      name: '__userDataBase',
      driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
    }),
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    ReduxStoreModule,
    LoggerModule.forRoot({
      level: NgxLoggerLevel.TRACE,
      serverLogLevel: NgxLoggerLevel.ERROR,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          const factory = new TranslationLoaderFactory(http);
          return factory.createForApp('plani8');
        },
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: 'environment',
      useValue: environment,
    },
    NavigationService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: ClientDetailsApiInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: GeneralApiHttpInterceptor, multi: true },
    InAppBrowser,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
